import React from "react";
import PropTypes from "prop-types";
import InlineSearch from "../InlineSearch/InlineSearch";
import $ from "jquery";

function stopBodyScrolling (bool) {
    if (bool === true) {
        document.body.addEventListener("touchmove", freezeVp, false);
    } else {
        document.body.removeEventListener("touchmove", freezeVp, false);
    }
}

const freezeVp = function(e) {
    e.preventDefault();
};

class HamburgerMenu extends React.Component {
    static propTypes = {
        menu: PropTypes.object,
        isSearchOn: PropTypes.bool,
    };

    static defaultProps = {
        menu: {},
        isSearchOn: false,
    };

    state = {
        open: false,
        menu: {}
    };
    createMarkup = (html) => {
        return {
            __html: html
        };
    }
    _toggleMenu = () => {
        // TODO: Sub-menu would never show if doing it this way. This has to be fixed.
        if(!this.state.open){
            $("html").addClass("fixed");
            $("#TopAd").addClass("closed");
            $("#MainHeader").addClass("mobile-open");
            stopBodyScrolling(true);
        } else {
            $("html").removeClass("fixed");
            $("#TopAd").removeClass("closed");
            $("#MainHeader").removeClass("mobile-open");
            stopBodyScrolling(false);
        }
        this.setState({open: !this.state.open});
    }
    _toggleMenuItem = (idx) => {
        let menu = Object.assign({}, this.state.menu);

        menu.children[idx].open = !menu.children[idx].open;

        this.setState({menu});
    }
    test =(e)=>{
        e.preventDefault();
    }
    _displayMenuItems = (child, idx) => {
        let hasChildren = typeof child.children !== "undefined" && child.children.length > 0;

        return (
            <div key={idx} className={(child.open)?"open":"closed"}>
                <li className="menuItem">
                    <a href={child.url} dangerouslySetInnerHTML={this.createMarkup(child.label)} onClick={this._toggleMenu} />
                </li>
                <ul className="subMenuItems">
                    {hasChildren && child.children.map((childOfChild, index) => {
                        return (
                            <li className="subMenuItem" key={index}>
                                <a href={childOfChild.url} dangerouslySetInnerHTML={this.createMarkup(childOfChild.label)} />
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
    _displayMenu = () => {
        let hasChildren = typeof this.state.menu.children !== "undefined" && this.state.menu.children.length > 0;

        return (
            <div className="menu-list-wrapper">
                <ul className="menuItems">
                    <InlineSearch classes="menu-search" isSearchOn={this.props.isSearchOn} open={true} static={true}/>
                    {hasChildren && this.state.menu.children.map((child, idx) => {
                        return (
                            this._displayMenuItems(child, idx)
                        );
                    })}
                    <li>
                        <a href="/academy" className="btn brandedButton">Lab Manager Academy</a>
                    </li>
                    <li>
                        <a href="/subscribe" className="btn brandedButton inverted">Subscribe Today!</a>
                    </li>
                </ul>
            </div>
        );
    }

    componentDidMount() {

        let menu = this.props.menu;

        if(menu.children) {
            for(let i = 0; i<menu.children.length; i++){
                menu.children[i].open = false;
            }
        }
        this.setState({menu});
    }

    render() {
        return (
            <React.Fragment>
                <div className={(this.state.open)?"menu open":"menu"}>
                    <button className="btn menu-button open-btn" title="Open Menu" onClick={this._toggleMenu}>
                        <i className="far fa-bars" aria-hidden="true"/>
                    </button>
                    <div className="menu-list">
                        <a id="menu-brand" href="/"></a>
                        <button className="menu-button close-btn" title="Close Menu" onClick={this._toggleMenu}>
                            <i className="far fa-times" aria-hidden="true"/>
                        </button>
                        {this._displayMenu()}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default HamburgerMenu;
